import React, { useState } from 'react'
import './style.scss'
import { Images } from '../../utils/Images'
import { Link } from 'react-router-dom'
import { useForm } from 'react-hook-form'

const Login = () => {
    const { register, handleSubmit, formState: { errors } } = useForm()
    const [isLoading, setLoading] = useState(false)

    // Submit data
    const onSubmit = async (data) => {
        try {
            setLoading(true)
            // console.log(data)
        } catch (error) {
            console.log(error)
        }
    }


    return (
        <div className="auth">
            <div className="container-fluid">
                <div className="row">

                    {/* Content column */}
                    <div className="col-12 col-lg-7 d-none d-lg-block p-0">
                        <div className="content-container">
                            <div className="flex-center flex-column">
                                <div className="logo-container">
                                    <img src={Images.Logo} className="img-fluid" alt="..." />
                                </div>
                                <h2>manage million user</h2>
                                <p>Taslima Marriage Media admin panel</p>

                                <ul>
                                    <li>
                                        <div className="image-container rounded-circle">
                                            <img src={Images.Image1} className="img-fluid" alt="..." />
                                        </div>
                                    </li>
                                    <li>
                                        <div className="image-container rounded-circle">
                                            <img src={Images.Image2} className="img-fluid" alt="..." />
                                        </div>
                                    </li>
                                    <li>
                                        <div className="image-container rounded-circle">
                                            <img src={Images.Image3} className="img-fluid" alt="..." />
                                        </div>
                                    </li>
                                    <li>
                                        <div className="image-container rounded-circle">
                                            <img src={Images.Image4} className="img-fluid" alt="..." />
                                        </div>
                                    </li>
                                </ul>
                                <ul>
                                    <li>
                                        <div className="image-container rounded-circle">
                                            <img src={Images.Image5} className="img-fluid" alt="..." />
                                        </div>
                                    </li>
                                </ul>
                            </div>
                        </div>
                    </div>

                    {/* Form column */}
                    <div className="col-12 col-lg-5 py-3 credential-container">
                        <div className="flex-center flex-column">
                            <div className="card border-0">
                                <div className="d-lg-none">
                                    <img src={Images.Logo} className="img-fluid" alt="..." />
                                </div>
                                <h3 className="mb-0">Recover Password!</h3>
                                <p className="mb-4">Enter your Email and instructions will be sent to you!</p>
                                <form onSubmit={handleSubmit(onSubmit)}>

                                    {/* E-mail */}
                                    <div className="form-group mb-4">
                                        {errors.email && errors.email.message ? (
                                            <p className="text-danger">{errors.email && errors.email.message}</p>
                                        ) : <p>E-mail</p>
                                        }

                                        <input
                                            type="text"
                                            name="email"
                                            className="form-control shadow-none"
                                            placeholder="Enter e-mail"
                                            {...register("email", {
                                                required: "E-mail is required",
                                                pattern: {
                                                    value: /^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,}$/i,
                                                    message: "Invalid email address"
                                                }
                                            })}
                                        />
                                    </div>

                                    <div className="d-flex">
                                        <div>
                                            <Link to="/">Go to Login</Link>
                                        </div>
                                        <div className="ml-auto">
                                            <button type="submit" className="btn shadow-none" disabled={isLoading}>
                                                {isLoading ? <span>Sending...</span> : <span>Reset</span>}
                                            </button>
                                        </div>
                                    </div>
                                </form>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
}

export default Login;